export default __webpack_public_path__ + "static/media/ThreeDServices.9ebffe51.svg";